// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/api_usage_alert/datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsApiUsageAlertDatatable } from "./constants";
import type { AppsApiUsageAlertDatatableParams, AppsApiUsageAlertDatatableResult } from "./types";

export const getApiUsageAlertDatatable = reactQueryTableFetcherAdapter(
  appsApiUsageAlertDatatable,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: AppsApiUsageAlertDatatableParams
  ): Promise<AppsApiUsageAlertDatatableResult> => {
    return fetch(
      "/api_usage_alert/datatable",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
